import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { RadioDdf } from '@td-client-frontend/common';
import React from 'react';
import { useDdf } from '../../context/ddf-context';

const RadioButton = (props) => {
  const { handlers } = useDdf();
  const { getState, change } = useFormApi();
  return <RadioDdf {...props} handlers={handlers} getState={getState} change={change} />;
};

export default RadioButton;
